<template>
  <md-dialog
    :md-active.sync="dialogVisible"
    :md-close-on-esc="false"
    :md-click-outside-to-close="false"
    class="are-you-still-there-dialog"
  >
    <md-dialog-title>Are you still there?</md-dialog-title>
    <md-dialog-content>
      <p class="modal-message"> It seems that you have left. Would you like to stay logged in? </p>
      <div class="countdown-container">
        <div class="countdown-text">
          You will be automatically logged out in <strong>{{ remainingTime }}</strong> seconds.
        </div>
        <div class="countdown-progress">
          <div class="countdown-bar" :style="{ width: progressPercentage + '%' }"></div>
        </div>
      </div>
    </md-dialog-content>

    <md-dialog-actions>
      <VasionButton id="btnSignout" classProp="secondary" @vasionButtonClicked="handleLogout">
        LOGOUT
      </VasionButton>
      <VasionButton
        id="btnStayLoggedIn"
        classProp="primary"
        @vasionButtonClicked="handleStay"
        ref="stayButton"
      >
        I'M STILL HERE
      </VasionButton>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
export default {
  name: 'AreYouStillThereModal',
  props: {
    duration: {
      type: Number,
      default: 30, // seconds
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      countdownTimer: null,
      remainingTime: this.duration,
    }
  },
  computed: {
    dialogVisible() {
      return this.visible
    },
    progressPercentage() {
      return (this.remainingTime / this.duration) * 100
    },
  },
  watch: {
    duration(newVal) {
      this.remainingTime = newVal
    },
    visible(newVal) {
      if (newVal) {
        this.startCountdown()
        this.$nextTick(() => {
          // Focus the primary button for accessibility
          if (this.$refs.stayButton) {
            this.$refs.stayButton.$el.focus()
          }
        })
      } else {
        this.stopCountdown()
      }
    },
  },
  beforeDestroy() {
    this.stopCountdown()
  },
  methods: {
    handleLogout() {
      this.stopCountdown()
      this.$emit('logout')
    },
    handleStay() {
      this.stopCountdown()
      this.$emit('stay')
    },
    handleTimeout() {
      this.stopCountdown()
      this.$emit('logout')
    },
    startCountdown() {
      this.remainingTime = this.duration
      this.countdownTimer = setInterval(() => {
        this.remainingTime--
        if (this.remainingTime <= 0) {
          this.handleTimeout()
        }
      }, 1000)
    },
    stopCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/light-theme-system-palette.scss';

.are-you-still-there-dialog {
  z-index: 10000 !important;
  .md-dialog-title {
    font-weight: 600;
  }
}

.modal-message {
  margin: 0 0 8px;
  font-size: 1rem;
  line-height: 1.5;
  color: $on-surface-variant;
  text-align: center;
}

.countdown-container {
  text-align: center;
  margin-bottom: 8px;
}

.countdown-text {
  font-size: 1.1rem;
  color: $error;
  margin-bottom: 16px;
  font-weight: 500;
}

.countdown-progress {
  width: 100%;
  height: 8px;
  background-color: $outline-variant;
  border-radius: 4px;
  overflow: hidden;
}

.countdown-bar {
  height: 100%;
  background: $primary;
  border-radius: 4px;
  transition: width 1s linear;
  transform-origin: left;
}

// Reduced motion support
@media (prefers-reduced-motion: reduce) {
  .countdown-bar {
    transition: none;
  }
}

.are-you-still-there-dialog {
  .md-title {
    font-size: 36px;
    text-align: center;
    font-weight: 500;
  }
  .md-dialog {
    z-index: 10001;
  }
  .md-dialog-content {
    padding: 0 16px 16px;
  }
  .md-dialog-actions {
    margin: auto;
    gap: 16px;
  }
}
</style>
